// @flow
import React from 'react';
import Helmet from 'react-helmet';
import { Link, graphql } from 'gatsby';
import Img from 'gatsby-image';
import Layout from '../../components/Layout';
import Tags from '../../components/Tags';
import SEO from '../../components/seo';

import s from './s.module.scss';

// $FlowIgnoreNextLine graphql
const Post = ({
  location,
  data: {
    site: {
      siteMetadata: { title: siteTitle },
    },
    markdownRemark: {
      frontmatter: { cover, thumbnail, title, subtitle, keywords, date },
      fields: { slug },
      excerpt,
      html,
    },
  },
}) => {
  const usedSocialMediaThumbnail =
    thumbnail || (cover ? cover.childImageSharp.sizes.src : null);
  const seoTitle = subtitle ? `${title} - ${subtitle}` : title;
  return (
    <Layout location={location} className={s.postPage}>
      <SEO
        title={seoTitle}
        description={`A blog post by Wei @wgao19: ${excerpt}`}
        keywords={keywords}
        imageUrl={usedSocialMediaThumbnail}
        slug={slug}
      />
      <article className={s.article}>
        <h1 className={s.title}>{title}</h1>
        {subtitle && <em className={s.subtitle}>{subtitle}</em>}
        <div className={s.frontmatter}>{date}</div>
        <div
          className={s.postContent}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </article>
    </Layout>
  );
};

export default Post;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        tags
        slug
      }
      frontmatter {
        title
        subtitle
        date(formatString: "MMMM DD, YYYY")
        thumbnail
        cover {
          childImageSharp {
            sizes(maxWidth: 720) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        coverCredit
        keywords
      }
    }
  }
`;
